import Controller from '@ember/controller'
import { action } from '@ember/object'
import type RouterService from '@ember/routing/router-service'
import { service } from '@ember/service'
import type RolloverStudentImportService from 'teacher-ui-client/services/rollover-student-import'

export default class ManageRolloverStudentImportInvalidController extends Controller {
  @service router!: RouterService

  @service rolloverStudentImport!: RolloverStudentImportService

  @action
  cancel() {
    this.rolloverStudentImport.clearJob()
    void this.router.replaceWith('manage.rollover.steps.students')
  }

  /**
   * Allows the user to set a file for a new import job, then transitions them to the validation page
   */
  @action
  selectCsvFile(event: Event) {
    const fileArray = event.target instanceof HTMLInputElement ? event.target.files : []
    if (fileArray && fileArray.length > 0) {
      const file = fileArray[0]
      this.rolloverStudentImport.setFile(file)
      void this.router.replaceWith('manage.rollover.steps.students.import.validate')
    }
  }
}
